import { GROUP_PREFIX } from './constants';
import { createFormItem } from './createFormItem';
import { createOrganizationUnit } from './createOrganizationUnit';
import { FormItem } from '../../types/types';
import {
  FormMap,
  Group,
  Section,
} from '../../components/Manager/DatasetForm/types';

export const processChildren = (
  parent: Section | FormMap,
  item: FormItem,
  index: number,
  groupMap: Map<string, any>
) => {
  // Resolve if parent is FormMap or Section
  const isRoot = parent instanceof Map;
  const itemsMap: Map<string | number, FormItem | Group | Section> = isRoot
    ? parent
    : parent.items;

  // If the item has defined group
  if (item.group) {
    const foundGroup = itemsMap.get(GROUP_PREFIX + item.group) as
      | Group
      | undefined;

    // Assign to existing group inside the parent
    if (foundGroup !== undefined) {
      foundGroup.items.set(index, createFormItem(item));
      return;
    }

    // Create new group inside the parent and assign item into it
    const group = groupMap.get(item.group);

    if (group === undefined) {
      throw new Error(`Group ${item.group} not found`);
    }

    // Assign new group into the parent
    const newGroup: Group = createOrganizationUnit(group, 'group');
    newGroup.items.set(index, createFormItem(item));
    itemsMap.set(GROUP_PREFIX + group.name, newGroup);
    return;
  }

  // Item has no group, then assign it into the section
  itemsMap.set(index, createFormItem(item));
  return;
};
